import FormControlLabel from './FormControlLabel'

export default FormControlLabel
